import MainLogo from "./assets/images/logo/mainlogo.png";
import MainLogoNoText from "./assets/images/logo/mainlogonotext.png";
import { Host } from "./models/hostModel";


// General
export const APP_NAME = 'Pappa Squat';
export const PREMIUM_PRICE_PER_MONTH: number = 9.99;
export const DEFAULT_BUILDING_IMAGE = require('./assets/images/building.jpg');
// Development requests stay same-origin and are forwarded by the CRA proxy in package.json.
// Production requests continue to use the hosted API unless explicitly overridden.
export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL
  ?? (process.env.NODE_ENV === 'development' ? '' : 'https://pappasquat.com/api');


export const MAIN_LOGO_IMAGE = MainLogo;
export const MAIN_LOGO_IMAGE_NO_TEXT = MainLogoNoText;


// Export other env fallbacks as needed
export const STRIPE_PUBLISH_KEY = process.env.REACT_APP_STRIPE_PUBLISH_KEY || "";


export const ENV = {
    NODE_ENV: process.env.NODE_ENV || 'development',
};

export const STRIKE_TYPES = {
    POOR_CONDITIONS: 'condition',
    SUSPEND_OR_BAN: 'suspend',
    NO_POST_USE_PICTURE: 'nopicture',
};



export const SUSPEND_USER_REASONS = [
    {   
        id: 1,
        name: 'Poor Conditions',
    },
    {   
        id: 2,
        name: 'Loitering or Misuse',
    },
    {   
        id: 3,
        name: 'Suspicious or Illegal Activity',
    },
    {   
        id: 4,
        name: 'Theft or Misuse of Supplies',
    },
    {   
        id: 5,
        name: 'Threats or Agressive Behavior',
    },
    {   
        id: 6,
        name: 'Vandalism or Property Damage',
    }
];

export const SUSPEND_MEMBER_TIME = [
    {   
        id: 7,
        name: '7 days',
    },
    {   
        id: 30,
        name: '30 days',
    },
    {   
        id: 60,
        name: '60 days',
    },
    {   
        id: 90,
        name: '90 days',
    },
    {   
        id: 360,
        name: '1 year',
    }
];



export const states = [
  { name: "Alabama", value: "AL" },
  { name: "Alaska", value: "AK" },
  { name: "Arizona", value: "AZ" },
  { name: "Arkansas", value: "AR" },
  { name: "California", value: "CA" },
  { name: "Colorado", value: "CO" },
  { name: "Connecticut", value: "CT" },
  { name: "Delaware", value: "DE" },
  { name: "Florida", value: "FL" },
  { name: "Georgia", value: "GA" },
  { name: "Hawaii", value: "HI" },
  { name: "Idaho", value: "ID" },
  { name: "Illinois", value: "IL" },
  { name: "Indiana", value: "IN" },
  { name: "Iowa", value: "IA" },
  { name: "Kansas", value: "KS" },
  { name: "Kentucky", value: "KY" },
  { name: "Louisiana", value: "LA" },
  { name: "Maine", value: "ME" },
  { name: "Maryland", value: "MD" },
  { name: "Massachusetts", value: "MA" },
  { name: "Michigan", value: "MI" },
  { name: "Minnesota", value: "MN" },
  { name: "Mississippi", value: "MS" },
  { name: "Missouri", value: "MO" },
  { name: "Montana", value: "MT" },
  { name: "Nebraska", value: "NE" },
  { name: "Nevada", value: "NV" },
  { name: "New Hampshire", value: "NH" },
  { name: "New Jersey", value: "NJ" },
  { name: "New Mexico", value: "NM" },
  { name: "New York", value: "NY" },
  { name: "North Carolina", value: "NC" },
  { name: "North Dakota", value: "ND" },
  { name: "Ohio", value: "OH" },
  { name: "Oklahoma", value: "OK" },
  { name: "Oregon", value: "OR" },
  { name: "Pennsylvania", value: "PA" },
  { name: "Rhode Island", value: "RI" },
  { name: "South Carolina", value: "SC" },
  { name: "South Dakota", value: "SD" },
  { name: "Tennessee", value: "TN" },
  { name: "Texas", value: "TX" },
  { name: "Utah", value: "UT" },
  { name: "Vermont", value: "VT" },
  { name: "Virginia", value: "VA" },
  { name: "Washington", value: "WA" },
  { name: "West Virginia", value: "WV" },
  { name: "Wisconsin", value: "WI" },
  { name: "Wyoming", value: "WY" },
];

export const amenitiesList = [
  { key: "handicapAccess", label: "Handicap Access" },
  { key: "familyRestroom", label: "Family Restroom" },
  { key: "womenBabyChangingStation", label: `Women's Baby Changing Station` },
  { key: "mensBabyChangingStation", label: `Men's Baby Changing Station` },
  { key: "disposableSeatCovers", label: `Disposable Seat Covers` },
  { key: "petFriendly", label: `Pet Friendly` },
  { key: "womensHygieneProducts", label: `Women's Hygiene Products` },
  { key: "mensHygieneProducts", label: `Men's Hygiene Products` },
  { key: "electricCarCharger", label: `Electric Car Charger` },
  { key: "motorcycleFriendly", label: `Motorcycle Friendly` },
  { key: "overnightParking", label: `Overnight Parking` },
  { key: "offerLuxury", label: "Luxury Experience" },
];
export const amenityKeyMap: Record<string, keyof Host> = {
  handicapAccess: "offerHandicapAccessible",
  familyRestroom: "offerFamilyRestroom",
  womenBabyChangingStation: "offerWomenBabyChaningTable",
  mensBabyChangingStation: "offerMenBabyChaningTable",
  disposableSeatCovers: "offerSeatCovers",
  petFriendly: "offerPetFriendly",
  womensHygieneProducts: "offerWomenProducts",
  mensHygieneProducts: "offerMenProducts",
  electricCarCharger: "offerAutoCharger",
  motorcycleFriendly: "motorcycleFriendly",
  overnightParking: "overnightFriendly",
  offerLuxury: "offerLuxury",
};
export const MESSAGE_AUTH = {
    ENTER_LOGIN_INFO: 'Enter your email and password.',
    FORGOT_PASSWORD_EMPTY_EMAIL: 'Enter your email to reset your password.',
    FORGOT_PASSWORD_EMAIL_SENT: 'Password reset email sent. Check your inbox.',
    FORGOT_PASSWORD_EMAIL_SENT_ERROR: `Couldn't send the reset email. Please try again.`,
    LOGIN_INFO_INCORRECT: 'Incorrect email or password.',
    LOGIN_INFO_EMAIL_NOT_CONFIRMED: `Account not activated.${'\n'}Check your inbox to confirm your email address.`,
    PROBLEM_LOGGING_OUT: 'Error logging out.',
    USER_ALREADY_REGISTERED_MESSAGE: `An account with this email already exists. Try resetting your password.`,
    USER_LOGGED_OUT: `You've been logged out.`,
};

export const MESSAGES_LOCATION = {
    ENTER_DOOR_LOCK_CODE: 'Enter Door Lock Code',
    ENTER_TIME_ALLOWED_PER_VISIT: 'Enter minutes allowed per visit.',
    HOST_PREMIUM_ONLY: 'Host Premium Members only?',
    DOOR_LOCK_CODE_REQUIRED: 'Require a door lock code for entry?',
    DOOR_LOCK_HAS_QR_READER: 'Does the lock have a QR reader?',
    OPTIONS_OFFER_HANDICAP: 'Is the restroom wheelchair accessible?',
    OPTIONS_OFFER_FAMILY: 'Do you offer a family restroom?',
    OPTIONS_OFFER_WOMEN_BABY_STATION: `Do you offer a women's baby changing station?`,
    OPTIONS_OFFER_MEN_BABY_STATION: `Do you offer a men's baby changing station?`,
    OPTIONS_OFFER_SEAT_COVERS: 'Do you provide toilet seat covers?',
    OPTIONS_OFFER_WET_WIPES: 'Do you provide wet wipes?',
    OPTIONS_OFFER_HAND_SANITIZER: 'Do you provide hand sanitizer?',
    OPTIONS_OFFER_PET_FRIENDLY: 'Is your business pet-friendly?',
    OPTIONS_PAYMENT_DETAILS: 'Enter Payment Details',
    OPTIONS_PRICE_PLAN_TITLE: 'Choose a Hosting Plan',
    OPTIONS_OFFER_WOMEN_PRODUCTS: `Do you provide women's hygiene products?`,
    OPTIONS_OFFER_MEN_PRODUCTS: `Do you provide men's hygiene products?`,
    OPTIONS_FREE_FOREVER: 'You get Free Hosting Forever!',
    OPTIONS_OFFER_MOTORCYCLE_FRIENDLY: 'Is your business motorcycle-friendly?',
    OPTIONS_OFFER_OVERNIGHT: 'Allow overnight stays?',
    OPTIONS_OFFER_CAR_CHARGER: 'Provide electric car charging?',
};
export const MESSAGES_ADDRESS_VERIFICATION = {
    ADDRESS_VERIFICATION_HOST_ALREADY_EXISTS: `A host already exists at this address.${'\n'}Please contact us if this is your business.`,
    ADDRESS_VERIFICATION_ERROR: 'There was a problem verifying the address. Please check the fields and try again.',
    ADDRESS_VERIFICATION_NOT_A_BUSINESS: `The entered address isn't recognized as a business.${'\n'}We'll allow it, but please double-check the details.`,
    ADDRESS_VERIFICATION_NOT_ABLE_TO_CONFIRM_ADDRESS: `We couldn't confirm this address.${'\n'}Please review and try again.`,
    ADDRESS_VERIFICATION_POBOX_NOT_ALLOWED: `P.O. Box addresses aren't allowed. Please enter a physical address.`,
};

export interface HostPricingPlanType{
    id: number;
    name: string;
    price: string;
    priceNumeric: number;
    features: Array<string>;
    productId: string;
    pricingId: string;
}

export const HOST_PRICING_PLANS: Array<HostPricingPlanType> = [
    {
      id: 1,
      name: "Host all Users",
      price: "$9.99/month",
      features: [
        "Draw the most customers",
        `Host all ${APP_NAME} users`,
        "Upgrade at any time",
        "Free Customer Support",
      ],
      priceNumeric: 9.99,
      //productId: 'prod_RhFRLA4U8FKWO9',// 'prod_RckVNtS2MwZgVq',
      productId: 'prod_RckVNtS2MwZgVq',// production,
      //pricingId: 'price_1QnqwdIk5duMG1vFd1yIxoRk', //test
      pricingId: 'price_1QjV0TIk5duMG1vFVdK4QRzf', //production
    },
    {
      id: 2,
      name: "Premium Host",
      price: "$19.99/month",
      features: [
        "Draw only the best customers",
        "Host only Premium Members",
        "Show in Custom User Searches",
        "Priority Customer Support",
      ],
      priceNumeric: 19.99,
      //productId: 'prod_RhFRrn2QjBpTMg',// test,
      productId: 'prod_RckWxE5t8sOsrq',// production,
      //pricingId: 'price_1QnqwGIk5duMG1vFJH8lUrGz', //test
      pricingId: 'price_1QjV1oIk5duMG1vFDoeOdije', //production
    },
  ];

export const STRIPE_CONFIG = {
    PUB_KEY: STRIPE_PUBLISH_KEY,
};

export const MESSAGES_VALIDATION = {
    VALIDATION_BUSINESS_HOURS: `Please review business hours.${'\n'}Opening time must be before closing time.`,
    VALIDATION_EMAIL: 'Enter a valid email address.',
    VALIDATION_CONFIRM_PASSWORD: 'Passwords do not match.',
    VALIDATION_DOOR_CODE: 'Door lock code must be a number.',
    VALIDATION_PHONE_NUMBER: 'Enter a valid phone number.',
    VALIDATION_PROFILE_PICTURE: 'Take a profile picture.',
    VALIDATION_TIME_ALLOWED: 'Time allowed per visit must be a number.',
    VALIDATION_PASSWORD: `Password must be at least 6 characters long, Contain at least 1 Uppercase letter, 1 number, and 1 special character.`,
    VALIDATION_REQUIRED_ADDRESS: 'Address is required',
    VALIDATION_REQUIRED_BUSINESS_NAME: 'Business name is required',
    VALIDATION_REQUIRED_CITY: 'City is required',
    VALIDATION_REQUIRED_DOOR_CODE: 'Enter a door code to continue',
    VALIDATION_REQUIRED_EMAIL: 'Email is required',
    VALIDATION_REQUIRED_FIRSTNAME: 'First name is required',
    VALIDATION_REQUIRED_PASSWORD: 'Password is required',
    VALIDATION_REQUIRED_PHONE_NUMBER: 'Phone number is required',
    VALIDATION_REQUIRED_LASTNAME: 'Last name is required',
    VALIDATION_REQUIRED_STATE: 'State is required',
    VALIDATION_REQUIRED_TIME_ALLOWED: 'Enter minutes allowed per visit',
    VALIDATION_REQUIRED_ZIP: 'ZIP code is required',
};
export const MESSAGES_ERROR = {
    ERROR_LOADING_CORPORATE_ACCOUNT_HOST_USERS: 'Error loading host users.',
    ERROR_DELETING_CORPORATE_ACCOUNT_HOST_USERS: 'Error deleting host user.',
    ERROR_DELETING_CORPORATE_ACCOUNT_ADMIN: 'Error deleting admin.',
    ERROR_INSERTING_CORPORATE_ACCOUNT_HOST_USERS: 'Error adding host user.',
    ERROR_UPDATING_CORPORATE_ACCOUNT_HOST_USERS: 'Error updating host user.',
    ERROR_UPDATING_CORPORATE_ACCOUNT_ADMIN: 'Error updating admin.',
    ERROR_LOADING_EXCEPTIONS: 'Error loading exceptions.',
    ERROR_LOADING_GOING_HISTORY: 'Error loading visit history.',
    ERROR_PROFILE_CHANGES: `Couldn't save profile changes. Please try again.`,
    ERROR_LOADING_POOR_CONDITION_REPORTS: 'Error loading condition reports.',
    ERROR_LOADING_SUSPENDED_USERS: 'Error loading suspended or banned users.',
    ERROR_LOADING_USER_SUSPENDS: 'Error loading your suspension or ban records.',
    ERROR_REGISTER_USER: 'Error creating your account. Please try again.',
    ERROR_UPLOADING_PROFILE_PICTURE: `Couldn't upload your picture. Please try again.`,
    ERROR_USER_ALREADY_REGISTERED: 'This user is already registered.',
    ERROR_DELETE_PROFILE: 'Error deleting your account. Please try again.',
};
